<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <div>
            <b-form class="d-flex" @submit.prevent="fetch(1)">
              <b-input-group class="input-group-merge mr-1 flex-grow-1">
                <b-input-group-prepend is-text>
                  <feather-icon icon="SearchIcon" size="16" class="text-muted" />
                </b-input-group-prepend>
                <b-form-input v-model="filter.q" placeholder="Recherche par Nom role" class="border-left-0" />
                <div
                  v-if="hasAnyFilter"
                  class="input-group-text reset-pill" title="Réinitialiser les filtres"
                  role="button"
                  tabindex="0"
                  @mousedown.prevent
                  @click="resetFilters"
                  @keyup.enter="resetFilters"
                >
                  <feather-icon icon="XIcon" size="14" class="text-danger mr-25" />
                  <span class="text-danger font-small-3">Réinitialiser</span>
                </div>
              </b-input-group>
              <b-button type="submit" variant="primary">Recherche</b-button>
            </b-form>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-card

        no-body
    >

      <div class="m-2">
        <b-button
            variant="primary"
            to="/roles/creer"
        >
          Créer role
        </b-button>
      </div>
      <b-table v-if="items"
               ref="selectableTable"
               :fields="fields"
               :items="items"

               responsive
               class="mb-0"

      >
        <template #cell(actions)="data">
          <b-button variant="gradient" class="btn-icon mr-1" :to="{ name: 'editer-role', params : {id : data.item.id }}">
            <feather-icon icon="EyeIcon"/>
          </b-button>
          <b-button variant="gradient-info" class="btn-icon mr-1" :disabled="busyId === data.item.id" @click="cloneRole(data.item)">
            <feather-icon icon="CopyIcon"/>
          </b-button>
          <b-button variant="gradient-danger" class="btn-icon" :disabled="busyId === data.item.id" @click="confirmDelete(data.item)">
            <feather-icon icon="TrashIcon"/>
          </b-button>
        </template>
      </b-table>


    </b-card>

    <div v-if="pagination.total" class="mx-2 mb-2">
      <b-row>
        <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
              v-model="pagination.current_page"
              :total-rows="pagination.total"
              :per-page="pagination.per_page"
              first-number
              last-number
              @change="fetch"
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>

import {
  BTable, BButton, BFormGroup, BAvatar, BBadge, BCardBody, BCard,
  BInputGroup, BInputGroupPrepend
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import axios from "@/libs/axios";
import filterPersistence from '@/mixins/filterPersistence'


export default {
  name : "RoleListPage",
  mixins: [filterPersistence],
  components: {
    BCard,
    BTable,
    BButton,
    BFormGroup,
    BAvatar,
    BCardBody,
    BBadge,
    BInputGroup,
    BInputGroupPrepend,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      filterKey: 'roles-list',
      pagination: {},
      fields: ['id', {key: 'libelle', label: 'Site'}, {key: 'actions'}],      /* eslint-disable global-require */
      items: [],
      filter: {
        q: ''
      },
      is_loading : false,
      busyId: null,
    }
  },
  created() {
    this.fetch(this.restoredPage || 1);
  },
  computed: {
    hasAnyFilter() {
      const f = this.filter || {};
      return Object.keys(f).some(k => {
        const v = f[k];
        return v !== null && v !== '' && !(Array.isArray(v) && v.length === 0);
      });
    }
  },
  methods: {
    resetFilters() {
      this.resetFilter();
      this.fetch(1);
    },
    fetch(page) {
      
      let _this = this;
      _this.is_loading = true;
      axios.get('/api/roles', {
        params: {
          page: page,
          q: _this.filter.q
        }
      }).then(function (responses){

        _this.items = responses.data.data;
        _this.pagination = responses.data.meta;
        _this.is_loading = false;
      })

    },
    cloneRole(role) {
      const _this = this;
      this.$bvModal.msgBoxConfirm(`Cloner le rôle "${role.libelle}" avec toutes ses permissions ?`, {
        title: 'Cloner rôle',
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Cloner',
        cancelTitle: 'Annuler',
        cancelVariant: 'outline-secondary',
        centered: true,
      }).then(value => {
        if (!value) return;
        _this.busyId = role.id;
        axios.post('/api/roles/' + role.id + '/clone').then(function (response) {
          _this.busyId = null;
          const newId = response.data.role && response.data.role.id;
          if (newId) {
            _this.$router.push({ name: 'editer-role', params: { id: newId } });
          } else {
            _this.fetch(_this.pagination.current_page || 1);
          }
        }).catch(function () {
          _this.busyId = null;
        });
      });
    },
    confirmDelete(role) {
      const _this = this;
      this.$bvModal.msgBoxConfirm(`Voulez-vous vraiment supprimer le rôle "${role.libelle}" ?`, {
        title: 'Supprimer rôle',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'Supprimer',
        cancelTitle: 'Annuler',
        cancelVariant: 'outline-secondary',
        centered: true,
      }).then(value => {
        if (!value) return;
        _this.busyId = role.id;
        axios.post('/api/roles/' + role.id + '/delete').then(function () {
          _this.busyId = null;
          _this.fetch(_this.pagination.current_page || 1);
        }).catch(function (error) {
          _this.busyId = null;
          if (error.response && error.response.status === 409) {
            const count = error.response.data.users_count;
            _this.$bvModal.msgBoxOk(
              `Impossible de supprimer ce rôle : ${count} utilisateur(s) y sont rattaché(s). Réaffectez-les d'abord à un autre rôle.`,
              {
                title: 'Suppression impossible',
                okVariant: 'danger',
                okTitle: 'OK',
                centered: true,
              }
            );
          }
        });
      });
    },
  },
}
</script>

<style lang="scss">
.reset-pill {
  background: #fdecec;
  border-color: #ebe9f1;
  border-left: 0;
  cursor: pointer;
  transition: background .15s ease;
  display: flex;
  align-items: center;
  user-select: none;
}
.reset-pill:hover {
  background: #fbd9d9;
}
</style>
 
